import BlogModel from './blog.model'
import fireApp from '../fireConfig.js'

class BlogService {
    constructor() {
        //this.posts = null;
    }

    lastPosts(callback) {
        //let component = this;
        let posts = [];

        fireApp.database().ref('blog/posts').orderByChild('timestamp').limitToLast(2).once('value').then(function(snapshot){
            

            snapshot.forEach(function(child) {
                var childData = child.val();
               
                childData.key = child.key;
                posts.push(childData);
                
            });
            callback(posts);
        })
    }

    nextPosts(key, callback) {
        let posts = [];

        console.log('filtro por: ' + key);
        

        fireApp.database().ref('blog/posts').orderByChild('timestamp').endAt(key).limitToLast(2).once('value').then(function(snapshot){
            
            snapshot.forEach(function(child) {
                var childData = child.val();
               
                childData.key = child.key;
                posts.push(childData);
                
            });

            callback(posts);
        })
    }

    getById(key, callback) {
        fireApp.database().ref('blog/posts/' + key).once('value').then(function(snapshot){
            var post = snapshot.val();
            callback(post);
        })
    }
}

export default BlogService 


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_site/src/services/blog/blog.service.js